import L from 'leaflet';
import "leaflet.fullscreen"
import {useEffect, useRef} from "react";
import {useMap} from "react-leaflet";
import './styles.css'

export function LeafletFullscreenControl(props) {
    const map = useMap();
    const ctrl = useRef(L.control.fullscreen(props));

    useEffect(() => {
        ctrl.current.addTo(map);

        return () => {
            ctrl.current.remove();
            ctrl.current.link.remove();
        };
    });

    return null;
}